<script>
export default {
  
};
</script>
<style lang="scss" scoped>
.lego-switch--disabled {
  cursor: default;
}
</style>
